import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface SearchParam {
  id: string;
  label: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
}

interface SearchParamsProps {
  params: SearchParam[];
}

export const SearchParams: React.FC<SearchParamsProps> = ({ params }) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const handleParamClick = (paramId: string) => {
    setOpenDropdown(openDropdown === paramId ? null : paramId);
  };

  const handleOptionSelect = (paramId: string, value: string) => {
    const param = params.find(p => p.id === paramId);
    if (param) {
      param.onChange(value);
    }
    setOpenDropdown(null);
  };

  return (
    <div className="content-stretch flex gap-[31px] items-center relative shrink-0">
      {params.map((param) => {
        const selectedOption = param.options.find(opt => opt.value === param.value);
        const isOpen = openDropdown === param.id;

        return (
          <div key={param.id} className="relative">
            <button
              onClick={() => handleParamClick(param.id)}
              className="content-stretch flex gap-[6px] items-center justify-center relative shrink-0 hover:bg-gray-50 rounded-lg p-1 transition-colors"
            >
              <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
                <div className="font-inter font-medium leading-[0] not-italic relative shrink-0 text-[#525866] text-[14px] text-center text-nowrap tracking-[-0.084px]">
                  <p className="leading-[20px] whitespace-nowrap">{selectedOption ? selectedOption.label : param.label}</p>
                </div>
              </div>
              <div className="bg-white content-stretch flex gap-[8px] items-start overflow-clip relative rounded-[24px] shrink-0">
                <div className="overflow-clip relative shrink-0 size-[20px]">
                  <ChevronDownIcon 
                    className={`h-5 w-5 text-[#525866] transition-transform ${isOpen ? 'rotate-180' : ''}`} 
                  />
                </div>
              </div>
            </button>

            {isOpen && (
              <>
                <div 
                  className="fixed inset-0 z-[9998]" 
                  onClick={() => setOpenDropdown(null)} 
                />
                <div className="absolute left-0 top-full mt-2 bg-white rounded-[8px] border border-[#e2e4e9] shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)] z-[9999] p-2 min-w-[120px]">
                  {param.options.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => handleOptionSelect(param.id, option.value)}
                      className={`w-full text-left px-3 py-2 rounded-[6px] text-[13px] transition-colors hover:bg-[#f6f8fa] whitespace-nowrap ${
                        param.value === option.value 
                          ? 'text-[#e16349]' 
                          : 'text-[#525866]'
                      }`}
                      style={param.value === option.value ? { backgroundColor: 'rgba(225, 99, 73, 0.1)' } : undefined}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SearchParams;
